import React from 'react';

export default function UberSubmitErrorModal({ show, errorMessage, onClose }) {
    if (!show) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
            onClick={onClose}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '6px',
                    padding: '0',
                    maxWidth: '480px',
                    width: '90%',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
                    overflow: 'hidden',
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    style={{
                        backgroundColor: '#dc3545',
                        padding: '16px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                    }}
                >
                    <i
                        className="fa fa-exclamation-circle"
                        style={{ fontSize: '22px', color: '#fff' }}
                    />
                    <h3 style={{ margin: 0, color: '#fff', fontSize: '18px', fontWeight: '600' }}>
                        Unable to Submit Ride
                    </h3>
                </div>

                <div style={{ padding: '20px' }}>
                    <div
                        style={{
                            padding: '14px',
                            backgroundColor: '#fff3cd',
                            border: '1px solid #ffc107',
                            borderRadius: '4px',
                            marginBottom: '20px',
                        }}
                    >
                        <p style={{ margin: 0, color: '#856404', lineHeight: '1.6', fontSize: '12px', whiteSpace: 'pre-line' }}>
                            {errorMessage || 'An error occurred while submitting the ride to Uber.'}
                        </p>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <button
                            onClick={onClose}
                            style={{
                                padding: '10px 28px',
                                backgroundColor: '#6c757d',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '14px',
                                fontWeight: '500',
                                lineHeight: '1',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}